var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"file-perm-chip"},[_c('div',{staticClass:"d-flex align-center"},[_vm._v(" "+_vm._s(_vm.pFilePermission.fileType.text)+" "),_vm._l((_vm.sortedEntityActions),function(it){return _c('div',{key:it.value,staticClass:"circle",class:_vm.getActionColor(it)},[_vm._v(_vm._s(it.text[0]))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }